// price: 1=200↓, 2=200-400, 3=400-800, 4=800↑
// origin: 1=香港, 2=澳洲, 3=日本, 4=台灣, 5=歐洲, 6=韓國, 8=美國, 9=英國, 11=加拿大, 13=法國, 14=泰國, 15=紐西蘭, 16=義大利, 17=德國, 18=西班牙, 25=比利時, 26=南非, 27=荷蘭, 29=瑞典, 37=奧地利
// factor: 2=乾肌, 3=混合肌, 4=油肌, 5=混合偏油肌, 6=混合偏乾肌, 7=敏感肌, 8=中性肌
// seo_keyword: 用於SEO的關鍵字
// seo_description: 用於SEO的描述
// alias: 顯示用的別名
export const keywordToFilters = {
  // ========== 價格條件 ==========
  新手學生: {
    pricing: 1,
    seo_keyword: '新手學生/平價',
    seo_description: '不高於$200的最平入門',
  },
  高性價比: {
    pricing: 2,
    seo_keyword: '高性價比/中價',
    seo_description: '$200-$400的中價/高性價比',
  },
  專櫃: {
    pricing: [3, 4],
    seo_keyword: '專櫃/貴婦級',
    alias: '專櫃/貴婦級',
    seo_description: '$400以上的少貴但好用',
  },

  // ========== 產地條件 ==========
  日本製: {
    origin: [3],
    seo_keyword: '日本必買/日本製',
    seo_description: '優質日產',
  },
  韓國製: {
    origin: [6],
    seo_keyword: '韓國必買/韓國製',
    seo_description: '優質韓國製',
  },
  台灣製: {
    origin: [4],
    seo_keyword: '台灣必買/台灣製',
    seo_description: '優質台灣製',
  },
  香港製造: {
    origin: [1],
    seo_keyword: '香港',
    seo_description: '優質香港本地製',
  },
  美加製造: {
    origin: [11, 8],
    seo_keyword: '美加',
    seo_description: '優質美加製',
  },
  英國製造: {
    origin: [9],
    seo_keyword: '英國',
    seo_description: '優質英國製',
  },
  泰國製造: {
    origin: [14],
    seo_keyword: '泰國',
    seo_description: '優質泰國製',
  },
  歐洲製造: {
    origin: [5, 17, 13, 16, 18, 25, 29, 27, 37],
    seo_keyword: '歐洲',
    seo_description: '優質歐洲製',
  },
  澳洲製造: {
    origin: [2, 26, 15],
    seo_keyword: '澳洲',
    seo_description: '優質澳洲製',
  },

  // ========== 膚質條件（factor）==========
  乾肌: {
    factor: [2],
    seo_keyword: '乾肌/滋潤',
    seo_description: '乾性肌膚適用',
  },
  混合肌: {
    factor: [3],
    seo_keyword: '混合肌',
    seo_description: '混合性肌膚適用',
  },
  油肌: {
    factor: [4],
    seo_keyword: '油肌/控油',
    seo_description: '油性肌膚適用',
  },
  混合油肌: {
    factor: [5],
    seo_keyword: '混油肌',
    seo_description: '混合偏油肌膚適用',
  },
  混合乾肌: {
    factor: [6],
    seo_keyword: '混乾肌',
    seo_description: '混合偏乾肌膚適用',
  },
  敏感肌: {
    factor: [7],
    seo_keyword: '敏感肌/溫和/低敏',
    seo_description: '敏感肌膚適用',
  },
  中性肌: {
    factor: [8],
    seo_keyword: '中性肌',
    seo_description: '中性肌膚適用',
  },

  // ========== 組合：價格 + 產地 ==========
  平價日本製: {
    pricing: 1,
    origin: [3],
    seo_keyword: '平價新手日本必買/日本製',
    seo_description: '$200以下 優質日本製熱門平替/入門',
  },
  平價韓國製: {
    pricing: 1,
    origin: [6],
    seo_keyword: '平價新手韓國必買/韓國製',
    seo_description: '$200以下 優質韓國製熱門平替/入門',
  },
  中價日本製: {
    pricing: 2,
    origin: [3],
    seo_keyword: '高性價比/中價日本必買/日本製',
    seo_description: '$200-$400的日本製中價/高性價比',
  },
  中價韓國製: {
    pricing: 2,
    origin: [6],
    seo_keyword: '高性價比/中價韓國必買/韓國製',
    seo_description: '$200-$400的韓國製中價/高性價比',
  },
  高級日本製: {
    pricing: [3, 4],
    origin: [3],
    seo_keyword: '專櫃/貴婦級日本必買/日本製',
    seo_description: '$400以上 頂級日本製奢華',
  },
  高級韓國製: {
    pricing: [3, 4],
    origin: [6],
    seo_keyword: '專櫃/貴婦級韓國必買/韓國製',
    seo_description: '$400以上頂級韓國製奢華',
  },

  // ========== 組合：價格 + 膚質 ==========
  平價乾肌: {
    pricing: 1,
    factor: [2],
    seo_keyword: '新手學生乾肌/平價滋潤',
    seo_description: '$200以下 專為乾性肌膚設計的保濕滋潤熱門平替/入門',
  },
  平價油肌: {
    pricing: 1,
    factor: [4],
    seo_keyword: '新手學生油肌/平價控油',
    seo_description: '$200以下 專為油性肌膚設計的清爽控油熱門平替/入門',
  },
  平價敏感肌: {
    pricing: 1,
    factor: [7],
    seo_keyword: '新手學生敏感肌/平價溫和/低敏',
    seo_description: '$200以下 專為敏感肌膚設計的溫和/低敏熱門平替/入門',
  },
  平價混合肌: {
    pricing: 1,
    factor: [3],
    seo_keyword: '新手學生混合肌/平價',
    seo_description: '$200以下 適合混合肌膚的平衡平替入門',
  },
  平價混乾肌: {
    pricing: 1,
    factor: [6],
    seo_keyword: '新手學生混乾肌/平價局部滋潤',
    seo_description: '$200以下 專為混合偏乾肌膚設計的平價局部滋潤',
  },
  平價混油肌: {
    pricing: 1,
    factor: [5],
    seo_keyword: '新手學生混油肌/平價局部控油',
    seo_description: '$200以下 專為混合偏油肌膚設計的平價局部控油',
  },
  中價乾肌: {
    pricing: 2,
    factor: [2],
    seo_keyword: '中價高性價比滋潤/乾肌',
    seo_description: '$200-$400 適合乾肌/滋潤的高性價比',
  },
  中價油肌: {
    pricing: 2,
    factor: [4],
    seo_keyword: '中價高性價比控油/油肌',
    seo_description: '$200-$400 適合油肌/控油的高性價比',
  },
  中價敏感肌: {
    pricing: 2,
    factor: [7],
    seo_keyword: '中價高性價比溫和/低敏/敏感肌',
    seo_description: '$200-$400 適合敏感肌/溫和/低敏的高性價比',
  },
  中價混合肌: {
    pricing: 2,
    factor: [3],
    seo_keyword: '中價高性價比/混合肌',
    seo_description: '$200-$400 適合平衡混合肌膚的高性價比',
  },
  中價混乾肌: {
    pricing: 2,
    factor: [6],
    seo_keyword: '中價高性價比局部滋潤/混乾肌',
    seo_description: '$200-$400 專為混合偏乾肌設計的高性價比局部滋潤',
  },
  中價混油肌: {
    pricing: 2,
    factor: [5],
    seo_keyword: '中價高性價比局部控油/混油肌',
    seo_description: '$200-$400 專為混合偏油肌設計的高性價比局部控油',
  },
  貴婦級乾肌: {
    pricing: [3, 4],
    factor: [2],
    seo_keyword: '貴婦級專櫃滋潤/乾肌',
    seo_description: '$400以上 專為乾性肌膚設計的頂級滋潤',
  },
  貴婦級油肌: {
    pricing: [3, 4],
    factor: [4],
    seo_keyword: '貴婦級專櫃控油/油肌',
    seo_description: '$400以上 專為油性肌膚設計的頂級控油清爽',
  },
  貴婦級敏感肌: {
    pricing: [3, 4],
    factor: [7],
    seo_keyword: '貴婦級專櫃低敏/敏感肌',
    seo_description: '$400以上 專為敏感肌膚設計的溫和低敏頂級',
  },
  貴婦級混合肌: {
    pricing: [3, 4],
    factor: [3],
    seo_keyword: '貴婦級專櫃平衡/混合肌',
    seo_description: '$400以上 專為混合肌膚設計的頂級平衡',
  },
  貴婦級混乾肌: {
    pricing: [3, 4],
    factor: [6],
    seo_keyword: '貴婦級專櫃局部滋潤/混乾肌',
    seo_description: '$400以上 專為混合偏乾肌設計的頂級局部滋潤',
  },
  貴婦級混油肌: {
    pricing: [3, 4],
    factor: [5],
    seo_keyword: '貴婦級專櫃局部控油/混油肌',
    seo_description: '$400以上 專為混合偏油肌設計的頂級局部控油',
  },

  // ========== 組合：產地 + 膚質 ==========
  日本製乾肌: {
    origin: [3],
    factor: [2],
    seo_keyword: '乾肌日本必買/日本製保濕滋潤',
    seo_description: '優質日產 專為乾性肌膚提供的深度滋潤保濕',
  },
  日本製油肌: {
    origin: [3],
    factor: [4],
    seo_keyword: '油肌日本必買/日本製控油清爽',
    seo_description: '優質日產 專為油性肌膚設計的清爽控油',
  },
  日本製敏感肌: {
    origin: [3],
    factor: [7],
    seo_keyword: '敏感肌日本必買/日本製溫和低敏',
    seo_description: '優質日產 專為敏感肌膚設計的溫和低敏',
  },
  日本製混合肌: {
    origin: [3],
    factor: [3],
    seo_keyword: '混合肌日本必買/日本製水油平衡',
    seo_description: '優質日產 適合混合肌膚的平衡保濕',
  },
  日本製混乾肌: {
    origin: [3],
    factor: [6],
    seo_keyword: '混乾肌日本必買/日本製局部滋潤',
    seo_description: '優質日產 專為混合偏乾肌設計的局部滋潤',
  },
  日本製混油肌: {
    origin: [3],
    factor: [5],
    seo_keyword: '混油肌日本必買/日本製局部控油',
    seo_description: '優質日產 專為混合偏油肌設計的局部控油',
  },
  韓國製乾肌: {
    origin: [6],
    factor: [2],
    seo_keyword: '乾肌韓國必買/韓國製保濕滋潤',
    seo_description: '優質韓國製 專為乾性肌膚提供的滋潤保濕',
  },
  韓國製油肌: {
    origin: [6],
    factor: [4],
    seo_keyword: '油肌韓國必買/韓國製控油清爽',
    seo_description: '優質韓國製 專為油性肌膚設計的清爽控油',
  },
  韓國製敏感肌: {
    origin: [6],
    factor: [7],
    seo_keyword: '敏感肌韓國必買/韓國製溫和低敏',
    seo_description: '優質韓國製 專為敏感肌膚設計的溫和低敏',
  },
  韓國製混合肌: {
    origin: [6],
    factor: [3],
    seo_keyword: '混合肌韓國必買/韓國製平衡',
    seo_description: '優質韓國製 適合混合肌膚的平衡控油',
  },
  韓國製混乾肌: {
    origin: [6],
    factor: [6],
    seo_keyword: '混乾肌韓國必買/韓國製局部滋潤',
    seo_description: '優質韓國製 專為混合偏乾肌設計的局部滋潤',
  },
  韓國製混油肌: {
    origin: [6],
    factor: [5],
    seo_keyword: '混油肌韓國必買/韓國製局部控油',
    seo_description: '優質韓國製 專為混合偏油肌設計的局部控油',
  },
};
